export const ExternalRemoteLinkPartial = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;
